// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Utils
import { getPublicLink } from './sharing/popup/publish/publishedBoardUtils';

// Components
import StaticURLField from '../../../components/form/fields/StaticURLField';

// Constants
import { APP_QUERY_PARAMS } from '../../../../common/utils/urlConstants';

const PublicBoardURLField = React.forwardRef(function PublicBoardURLField(props, ref) {
    const { currentBoardId, permissionsId, showSpinner } = props;

    const [forceLoader, setForceLoader] = React.useState(!permissionsId);

    React.useEffect(() => {
        if (!forceLoader) return;

        const timeoutId = setTimeout(() => setForceLoader(false), 500);

        return () => clearTimeout(timeoutId);
    }, []);

    const permissionUrl =
        forceLoader || !permissionsId
            ? `${getPublicLink(currentBoardId)}?${APP_QUERY_PARAMS.PERMISSION}=...`
            : `${getPublicLink(currentBoardId)}?${APP_QUERY_PARAMS.PERMISSION}=${permissionsId}`;

    return <StaticURLField ref={ref} url={permissionUrl} showSpinner={showSpinner} />;
});

PublicBoardURLField.propTypes = {
    currentBoardId: PropTypes.string,
    permissionsId: PropTypes.string,
    showSpinner: PropTypes.bool,
};

export default PublicBoardURLField;
